import { Callback } from "game-common/models"
import { Graphics } from "pixi.js"

interface FaderProps {
    direction?: "in" | "out"
    releaseCallback?: Callback
    minAlpha?: number
    fadeInterval?: number
    fadeAlphaDecrement?: number
}

interface AlphaAware {
    alpha: number
}

export class Fader {
    private interval: any
    private minAlpha: number
    private subject: AlphaAware
    private releaseCallback?: Callback
    private fadeInterval: number
    private faderStep = 0.01
    private direction: "in" | "out" = "out"
    private active: boolean

    constructor(subject: AlphaAware, props?: FaderProps) {
        this.subject = subject
        this.releaseCallback = props?.releaseCallback
        this.minAlpha = props?.minAlpha !== undefined ? props.minAlpha : this.direction === "out" ? 0.0 : 1.0
        this.fadeInterval = props?.fadeInterval || 2
        this.faderStep = props?.fadeAlphaDecrement || 0.01
        this.direction = props?.direction || "out"
    }

    isActive = () => this.active

    update = () => {
        this.active = true
        if (this.interval) {
            return
        }
        this.interval = setInterval(() => {
            if (this.direction === "out") {
                this.subject.alpha -= this.faderStep
                if (this.subject.alpha <= this.minAlpha) {
                    this.releaseCallback && this.releaseCallback()
                    clearInterval(this.interval)
                    this.interval = undefined
                    return
                }
            } else if (this.direction === "in") {
                this.subject.alpha += this.faderStep
                if (this.subject.alpha >= this.minAlpha) {
                    this.releaseCallback && this.releaseCallback()
                    clearInterval(this.interval)
                    this.interval = undefined
                    return
                }
            } else {
                // not supported, clear it right away
                clearInterval(this.interval)
                this.interval = undefined
            }
        }, this.fadeInterval)
    }

    stop = (suppressCallback?: boolean) => {
        if (this.interval) {
            clearInterval(this.interval)
            this.interval = undefined
        }
        if (!suppressCallback && this.releaseCallback) {
            this.releaseCallback()
        }
        this.active = false
    }
}
